import React from 'react';
import Smiley from '../components/Smiley';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useSelector } from 'react-redux';

const SmileyWithEditButton = ({
    setShowSmileySelector,
    showSmileySelector
}) => {
    const { theme, editedProfile } = useSelector((state) => state.application);

    const { ref: smileySelectorRef, focused: smileySelectorFocused } = useFocusable({
        focusKey: "smiley-selector",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
        onEnterRelease: () => { setShowSmileySelector(!showSmileySelector); },
    });
    return (
        <FocusContext.Provider value={"smiley-selector"} >
            <div ref={smileySelectorRef} style={{ position: "relative" }} >
                <Smiley focusable={false} size='150px' profile={editedProfile} pointer={false} />
                <div style={{ height: "40px", width: "40px", borderRadius: "50%", backgroundColor: smileySelectorFocused ? "black" : "white", position: "absolute", right: "-15px", bottom: "10px", display: 'flex', justifyContent: "center", alignItems: "center", cursor: "pointer", border: smileySelectorFocused ? "2px solid #007FFF" : "2px solid transparent" }} onClick={() => { setShowSmileySelector(!showSmileySelector) }}><i className='fa fa-pencil fa-lg' style={{ color: smileySelectorFocused ? "white" : "black" }} />
                </div>
            </div>
        </FocusContext.Provider>
    );
}

export default SmileyWithEditButton;
